export function isRunningInWebview() {
  try {
    return window.location.pathname.includes('app');
  } catch (e) {
    return true;
  }
}
